import { motion } from "framer-motion";

const stages = [
  {
    title: "Recognition",
    description: "The initial spark of connection and profound familiarity.",
    icon: "✨",
  },
  {
    title: "Awakening",
    description: "Spiritual growth and heightened awareness begins.",
    icon: "🌱",
  },
  {
    title: "Testing",
    description: "Challenges arise to strengthen the connection.",
    icon: "⚡",
  },
  {
    title: "Running/Chasing",
    description: "One twin runs while the other pursues connection.",
    icon: "🏃",
  },
  {
    title: "Surrender",
    description: "Accepting the journey and divine timing.",
    icon: "🕊️",
  },
  {
    title: "Reunion",
    description: "Coming together in divine timing and harmony.",
    icon: "💫",
  },
];

export const StagesSection = () => {
  return (
    <section className="py-24 bg-gradient-to-b from-white to-spirit-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <span className="inline-block px-3 py-1 text-sm font-medium bg-spirit-100 text-spirit-700 rounded-full">
            The Journey
          </span>
          <h2 className="mt-4 text-4xl font-serif font-medium text-gray-900">
            Twin Flame Stages
          </h2>
          <p className="mt-4 text-xl text-gray-600 max-w-2xl mx-auto">
            Understanding the stages of a twin flame journey can help you navigate
            this profound spiritual connection.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {stages.map((stage, index) => (
            <motion.div
              key={stage.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="p-6 bg-white rounded-2xl shadow-sm hover:shadow-md transition-shadow duration-200 border border-gray-100"
            >
              <div className="text-3xl mb-4">{stage.icon}</div>
              <h3 className="text-xl font-medium text-gray-900 mb-2">
                {stage.title}
              </h3>
              <p className="text-gray-600">{stage.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};